import React from 'react';
import { CrosshairIcon, TargetIcon } from 'lucide-react';
export function ShootingDisciplines() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2686">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2687">
        <div className="mb-12" data-id="element-2688">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2689">
            Shooting Disciplines
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2690">
            {/* Combat */}
            <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2691">
              <div className="flex items-center gap-3 mb-4" data-id="element-2692">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
                backgroundColor: 'rgba(200,168,75,0.15)'
              }} data-id="element-2693">
                  <CrosshairIcon size={20} style={{
                  color: '#c8a84b'
                }} data-id="element-2694" />
                </div>
                <h3 className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2695">
                  Combat
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2696">
                <li className="flex items-start gap-2" data-id="element-2697">
                  <span className="text-c8a84b mt-1" data-id="element-2698">•</span>
                  <span className="text-base text-gray-800" data-id="element-2699">6" Barrel</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2700">
                  <span className="text-c8a84b mt-1" data-id="element-2701">•</span>
                  <span className="text-base text-gray-800" data-id="element-2702">60 Rounds</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2703">
                  <span className="text-c8a84b mt-1" data-id="element-2704">•</span>
                  <span className="text-base text-gray-800" data-id="element-2705">
                    Minimum 4 Magazine or Speed Loaders Required
                  </span>
                </li>
              </ul>
            </div>

            {/* Service */}
            <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2706">
              <div className="flex items-center gap-3 mb-4" data-id="element-2707">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
                backgroundColor: 'rgba(30,61,47,0.08)'
              }} data-id="element-2708">
                  <TargetIcon size={20} style={{
                  color: '#1e3d2f'
                }} data-id="element-2709" />
                </div>
                <h3 className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2710">
                  Service
                </h3>
              </div>
              <div className="space-y-4" data-id="element-2711">
                <div data-id="element-2712">
                  <h4 className="font-semibold text-sm text-gray-600 uppercase tracking-wider mb-2" data-id="element-2713">
                    Revolver
                  </h4>
                  <ul className="space-y-1" data-id="element-2714">
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2715">
                      <span className="text-gray-400" data-id="element-2716">•</span> -4" Barrel
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2717">
                      <span className="text-gray-400" data-id="element-2718">•</span> 60 Rounds
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2719">
                      <span className="text-gray-400" data-id="element-2720">•</span> Minimum 4 Speed
                      Loaders Required
                    </li>
                  </ul>
                </div>
                <div data-id="element-2721">
                  <h4 className="font-semibold text-sm text-gray-600 uppercase tracking-wider mb-2" data-id="element-2722">
                    Semi-Auto
                  </h4>
                  <ul className="space-y-1" data-id="element-2723">
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2724">
                      <span className="text-gray-400" data-id="element-2725">•</span> -5" Barrel
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2726">
                      <span className="text-gray-400" data-id="element-2727">•</span> 60 Rounds
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-800" data-id="element-2728">
                      <span className="text-gray-400" data-id="element-2729">•</span> Minimum 4
                      Magazine Required
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Unlimited Class */}
            <div className="bg-white rounded-xl p-6 shadow-sm border md:col-span-2 relative overflow-hidden" style={{
            borderColor: '#c8a84b',
            borderWidth: '2px'
          }} data-id="element-2730">
              <div className="absolute top-0 right-0 bg-[#c8a84b] text-[#1a1a1a] text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-bl-lg" data-id="element-2731">
                New
              </div>
              <div className="flex items-center gap-3 mb-4" data-id="element-2732">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
                backgroundColor: 'rgba(200,168,75,0.15)'
              }} data-id="element-2733">
                  <TargetIcon size={20} style={{
                  color: '#c8a84b'
                }} data-id="element-2734" />
                </div>
                <h3 className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2735">
                  Unlimited Class
                </h3>
              </div>
              <p className="text-base text-gray-800 mb-4" data-id="element-2736">
                Open to any caliber pistol / ammo allowed on the FLSC indoor
                range from .22 and up.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-2737">
                <li className="flex items-start gap-2" data-id="element-2738">
                  <span className="text-c8a84b mt-1" data-id="element-2739">•</span>
                  <span className="text-base text-gray-800" data-id="element-2740">
                    Optical sights allowed but <strong data-id="element-2741">NO LASERS</strong>
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2742">
                  <span className="text-c8a84b mt-1" data-id="element-2743">•</span>
                  <span className="text-base text-gray-800" data-id="element-2744">
                    As with all classes, appropriate equipment such as holsters
                    and magazines is required.
                  </span>
                </li>
              </ul>
              <div className="flex flex-col sm:flex-row gap-4 mt-4 p-4 rounded-lg bg-gray-50 border border-gray-100" data-id="element-2745">
                <div className="flex-1" data-id="element-2746">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-2747">
                    Revolvers
                  </span>
                  <span className="text-sm font-medium text-gray-800" data-id="element-2748">
                    Minimum 4 Speed Loaders Required
                  </span>
                </div>
                <div className="flex-1" data-id="element-2749">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-2750">
                    Semi-Auto
                  </span>
                  <span className="text-sm font-medium text-gray-800" data-id="element-2751">
                    Minimum 4 Magazine Required
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}